import { render, staticRenderFns } from "./SafariPwaGuidePopup.vue?vue&type=template&id=65b951b1&scoped=true&"
import script from "./SafariPwaGuidePopup.vue?vue&type=script&lang=js&"
export * from "./SafariPwaGuidePopup.vue?vue&type=script&lang=js&"
import style0 from "./SafariPwaGuidePopup.vue?vue&type=style&index=0&id=65b951b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b951b1",
  null
  
)

export default component.exports